import React, {useContext, useEffect} from "react";
import {Outlet, Link, useNavigate} from "react-router-dom";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import BreadcrumbInterface from "../../interfaces/core/BreadcrumbInterface";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";

export default function Layout() {
    const menu = [
        {name: 'Мои данные', icon: 'fas fa-user', link: '/account/profile'},
        {name: 'Новый заказ', icon: 'fas fa-shopping-bag', link: '/basket'},
        {name: 'Мои заказы', icon: 'fas fa-shopping-bag', link: '/account/order-list'},
        // {name: 'Мои предзаказы', icon: 'fas fa-shopping-bag', link: '/account/second'},
        // {name: 'Скачать прайс-лист', icon: 'fas fa-shopping-bag', link: '/account/second'},
    ]

    const [_, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const navigate = useNavigate();


    useEffect(() => {
        let breadcrumbs: BreadcrumbInterface[] = [];

        breadcrumbs.push({
            name: 'Личный кабинет',
        })
        dispatch({type: ReducerActionType.SET_BREADCRUMBS, payload: breadcrumbs})
    }, []);

    const logout = () => {
        dispatch({ type: 'SET_CUSTOMER', payload: null });
        navigate('/')
    }


    return (<div className="container">
        {/* Горизонтальное мобильное меню */}
        <div className="d-lg-none mb-4 border-bottom">
            <div className="mobile-horizontal-menu bg-white rounded-3 p-2">
                <nav className="nav justify-content-center">
                    {menu.map((item, index) => (
                        <Link 
                            key={index}
                            to={item.link} 
                            className="nav-link d-flex flex-column align-items-center py-2 px-3 rounded-2 mx-1 text-decoration-none text-dark"
                        >
                            <i className={`${item.icon} mb-1 text-primary`}></i>
                            {item.name}
                        </Link>
                    ))}
                    <span
                        className="nav-link d-flex flex-column align-items-center py-2 px-3 rounded-2 mx-1 text-decoration-none text-dark"
                        onClick={logout}
                    >
                        <i className={` mb-1 text-primary`}></i>
                        Выход
                    </span>
                </nav>
            </div>
        </div>

        <div className={'gx-3 gx-md-6 row gy-7  mb-5'}>
            {/* Вертикальное меню для десктопа */}
            <div className="col-0 col-lg-3 d-none d-lg-block position-relative">
                <div className="filter rounded-4">
                    <nav className="nav flex-column pb-4 pt-5">
                        {menu.map((item, index) => (
                            <Link 
                                key={index}
                                to={item.link} 
                                className="nav-link d-flex align-items-center pb-3 px-3 rounded-2 mb-2 text-decoration-none text-dark"
                            >
                                <i className={`${item.icon} me-3 text-primary`}></i>
                                {item.name}
                            </Link>
                        ))}
                        <span
                            className="pointer nav-link d-flex align-items-center pb-3 px-3 rounded-2 mb-2 text-decoration-none text-dark"
                            onClick={logout}

                        >
                            <i className={` me-3 text-primary`}></i>
                            <b>Выход</b>
                        </span>
                    </nav>
                </div>
            </div>
            <div className="col-12 col-lg-9">
                <Outlet />
            </div>
        </div>
    </div>);
}